import { Product } from 'src/api';
import { integrationAddOnFeatureFromProduct } from './integration-addon.util';

/** Feature flags the Deubner content add-ons grant (Stripe product metadata `features`). */
export const DEUBNER_CONTENT_FEATURE = 'deubner_content';
export const DEUBNER_TAX_CONTENT_FEATURE = 'deubner_tax_content';

/** True when the add-on grants exactly this feature flag. */
export function isAddonForFeature(product: Product, feature: string): boolean {
  return integrationAddOnFeatureFromProduct(product) === feature;
}

/** Identifies the additional-credits add-on (excludes Deubner content products by name). */
export function isCreditsAddonProduct(product: Product): boolean {
  const name = product.name?.toLowerCase() || '';
  return name.includes('credit') && !name.includes('deubner');
}

export function creditsAddonRequiresTopTierSeat(partner: string | null | undefined): boolean {
  return partner !== 'deubner';
}

/**
 * Whether the additional-credits package can be added or raised: it is sold to Deubner firms only.
 *
 * Elsewhere it is still in the catalogue for the firms that already have it, which keep it until they
 * remove it — so it stays visible for them, capped at what they hold. The backend refuses more.
 */
export function creditsAddonIsBookable(partner: string | null | undefined): boolean {
  return partner === 'deubner';
}
